import React, { ReactNode } from 'react';
import styles from './index.less';

type ServiceTimelineItemsType = {
  label: ReactNode;
  content: ReactNode;
};

type ServiceTimelineProps = {
  items: ServiceTimelineItemsType[];
};

const ServiceTimeline = (props: ServiceTimelineProps) => {
  const { items } = props;
  return (
    <ul className={styles.timeline}>
      {items?.map((item: ServiceTimelineItemsType, index: number) => (
        <li className={styles.timelineItem} key={index}>
          <div className={styles.timelineItemTail}></div>
          <div className={styles.timelineItemHead}>{item.label}</div>
          <div className={styles.timelineItemContent}>{item.content}</div>
        </li>
      ))}
    </ul>
  );
};

export default ServiceTimeline;
